document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get('pq-cart-select-menu')) {
    customElements.define(
      'pq-cart-select-menu',
      class CartSelectMenu extends HTMLElement {
        constructor() {
          super();
          this.container = null;
          this.header = null;
          this.valueSpan = null;
          this.optionsList = null;
          this.optionsContainer = null;
          this.arrowIcon = null;
          this.$current_inventory_quantity = 0;
          this.$currentPrice = 0;
          this.$currentId = 0;
          this.$currentComparePrice = 0;
          this.$currentRecommendId = 0;
          this.$currentQuantity = 1;
          this.productId = null;
          this._documentClickBound = false;
          this.totalPrice = 0;
          this.totalComparePrice = 0;
          this.totalDiscount = 0;
          this.priceContribution = {
            price: 0,
            comparePrice: 0,
            discount: 0,
          };
          this.$cartRecommentSwiper = null;
        }

        connectedCallback() {
          const selectHeaders = this.querySelectorAll('.select-header');
          selectHeaders.forEach((header) => {
            const valueSpan = header.querySelector('.select-value');
            const optionsContainer = header.nextElementSibling;
            const arrowIcon = header.querySelector('.arrow-icon');
            const optionsList = optionsContainer?.querySelector('ul');
            header._elements = {
              valueSpan,
              optionsContainer,
              arrowIcon,
              optionsList,
            };
            if (header && optionsContainer) {
              // 点击 header 展开/收起
              header.addEventListener('click', (e) => {
                e.stopPropagation();
                const elements = header._elements;
                this.toggle(header, elements.optionsContainer, elements.valueSpan, elements.arrowIcon);
              });

              // 点击选项
              optionsList?.addEventListener('click', (e) => {
                const option = e.target.closest('.select-option');
                if (option) {
                  e.stopPropagation();
                  const inventoryQuantity = option.getAttribute('data-inventory_quantity');
                  if (inventoryQuantity > 0) {
                    const elements = header._elements;
                    this.selectOption(option, header, elements);
                  } else {
                  }
                } else {
                }
              });
            }
          });

          // 点击外部关闭所有下拉
          this.addEventListener('click', () => {
            selectHeaders.forEach((header) => {
              const elements = header._elements;
              if (elements) {
                this.close(header, elements.optionsContainer, elements.valueSpan, elements.arrowIcon);
              }
            });
          });

          // Swiper 初始化
          this.$cartRecommentSwiper = this.querySelector('.cart-recommend-swiper');
          if (this.$cartRecommentSwiper) {
            this.initSwiper();
            this.initEveryOption();
          }
          // 初始化加入购物车按钮
          this.initJoinCartButton();
          // 初始化默认选中选项
          this.initDefaultSelectedOptions();

          // 监听 global-select 的选项点击事件
          this.initGlobalSelectListener();
        }

        initGlobalSelectListener() {
          document.addEventListener('global-select:option-click', (e) => {
            const { data, trigger, item, componentType } = e.detail;
            this.currentOption = item;
            // 只处理购物车推荐商品的事件
            if (componentType !== 'cart-recommend') return;

            // 找到对应的 select-header
            const header = trigger;
            const elements = header._elements;

            if (!elements) return;

            // 调用 selectOption 方法
            this.selectOption(item, header, elements);
          });
        }

        toggle(header, optionsContainer, valueSpan, arrowIcon) {
          const isActive = header.classList.contains('cart-active-select-menu');

          if (!isActive) {
            // 展开
            header.classList.add('cart-active-select-menu');
            optionsContainer.style.maxHeight = '300px';
            optionsContainer.style.opacity = '1';
            optionsContainer.style.zIndex = '300';
            valueSpan.style.color = '#acacac';
            arrowIcon.style.transform = 'rotate(-180deg)';
          } else {
            // 收起
            this.close(header, optionsContainer, valueSpan, arrowIcon);
          }
        }

        close(header, optionsContainer, valueSpan, arrowIcon) {
          header.classList.remove('cart-active-select-menu');
          optionsContainer.style.maxHeight = '0';
          optionsContainer.style.opacity = '0';
          optionsContainer.style.zIndex = '1';
          valueSpan.style.color = '';
          arrowIcon.style.transform = '';
        }

        selectOption(option, header, elements) {
          const { valueSpan, optionsContainer, arrowIcon, optionsList } = elements;
          // 找到当前选项所在的 select-menu 容器 - 修复选择器
          const currentSelectMenu = option.closest('pq-cart-select-menu') || this;

          if (!currentSelectMenu) {
            return;
          }

          // 更新选中状态
          const allOptions = optionsList.querySelectorAll('.select-option, .select-options-item');
          allOptions.forEach((opt) => {
            opt.classList.remove('text-orange-500', 'selected', 'active');
          });
          option.classList.add('text-orange-500', 'selected', 'active');

          // 获取选项文本（优先使用 .select-option-item-text）
          const optionText = option.querySelector('.select-option-item-text');
          const newText = optionText ? optionText.textContent.trim() : option.textContent.trim();
          valueSpan.textContent = newText;



          // 更新当前选中项的价格和库存信息
          this.$current_inventory_quantity =
            option.getAttribute('data-inventory_quantity') != 0
              ? parseInt(option.getAttribute('data-inventory_quantity'))
              : 1;
          this.$currentPrice = this.parsePriceString(option.getAttribute('data-price'));
          this.$currentId = this.parsePriceString(option.getAttribute('data-variant_id'));
          this.$currentComparePrice = this.parsePriceString(option.getAttribute('data-compare_at_price'));

          // 获取当前产品的 ID
          const currentProductId = option.getAttribute('data-recommend-id');
          this.productId = currentProductId;
          // 在当前 select-menu 中查找对应产品的 option-container
          const optionContainer = currentSelectMenu.querySelector(
            `.option-container[data-product-id="${currentProductId}"]`
          );


          if (optionContainer) {
            const quantityInput = optionContainer.querySelector('input[type="text"]');

            if (quantityInput) {
              // 更新最大值
              quantityInput.max = this.$current_inventory_quantity;

              // 检查当前数量是否超过新的最大值
              const currentQuantity = parseInt(quantityInput.value);
              if (currentQuantity > this.$current_inventory_quantity) {
                // 如果超过了，将数量调整为新的最大值
                quantityInput.value = this.$current_inventory_quantity;
                this.$currentQuantity = this.$current_inventory_quantity;
              } else {
                // 如果没超过，保持当前数量
                this.$currentQuantity = currentQuantity;
              }

            }
          } else {
            // 尝试其他可能的选择器
            const alternativeContainer = this.querySelector(`.option-container[data-product-id="${currentProductId}"]`);
          }

          // 更新价格显示
          this.updateOptionPrice();

          // 关闭下拉
          this.close(header, optionsContainer, valueSpan, arrowIcon);
        }

        initEveryOption() {
          // 获取所有选项列表
          const lists = this.querySelectorAll('.select-options-list');

          lists.forEach((list) => {
            // 获取所有选项
            const options = list.querySelectorAll('.select-options-item, .select-option');

            let selectedOption = null;

            // 先移除所有选项的 active 类
            options.forEach((option) => {
              option.classList.remove('active');
            });

            // 查找匹配的选项 - 根据 data-variant_id 和 data-selected_or_first_available_variant 的匹配
            options.forEach((option) => {
              const dataId = option.getAttribute('data-variant_id');
              const dataSelectedOrFirstAvailable = option.getAttribute('data-selected_or_first_available_variant');

              // 如果 data-variant_id 和 data-selected_or_first_available_variant 完全匹配，则选择这个选项
              if (dataId && dataSelectedOrFirstAvailable && dataId === dataSelectedOrFirstAvailable) {
                selectedOption = option;
                return;
              }
            });

            // 如果没有找到匹配的选项，则选择第一个作为默认选项
            if (!selectedOption && options.length > 0) {
              selectedOption = options[0];
            }

            if (!selectedOption) return;

            // 给选中的选项添加 active 类
            selectedOption.classList.add('active');

            // 获取当前产品的信息
            const current_inventory_quantity = selectedOption.getAttribute('data-inventory_quantity');
            const currentPrice = this.parsePriceString(selectedOption.getAttribute('data-price'));
            const currentId = this.parsePriceString(selectedOption.getAttribute('data-variant_id'));
            const currentComparePrice = this.parsePriceString(selectedOption.getAttribute('data-compare_at_price'));
            const currentRecommendId = selectedOption.getAttribute('data-recommend-id'); // 不要转换为数字

            // 找到对应的数量输入框容器
            const quantityContainer = this.querySelector(`.option-container[data-product-id="${currentRecommendId}"]`);
            if (!quantityContainer) return;

            // 初始化默认价格显示 - 直接更新对应产品的价格元素
            this.updateSpecificProductPrice(currentRecommendId, currentPrice, currentComparePrice, 1);

            // 设置对应的数量输入框
            const quantityInput = quantityContainer.querySelector('input[type="text"]');
            if (quantityInput) {
              // 设置最大值
              quantityInput.max = current_inventory_quantity;

              // 监听输入事件
              quantityInput.addEventListener('input', (event) => {
                let newValue = parseInt(event.target.value);
                const maxValue = parseInt(quantityInput.max);

                // 限制输入范围
                if (isNaN(newValue) || newValue < 1) {
                } else if (newValue > maxValue) {
                  newValue = maxValue;
                  quantityInput.value = maxValue;
                }

                // 只在有效范围内更新价格
                if (newValue >= 1 && newValue <= maxValue) {
                  // 直接更新对应产品的价格
                  this.updateSpecificProductPrice(currentRecommendId, currentPrice, currentComparePrice, newValue);
                }
              });

              // 失去焦点时确保数值正确
              quantityInput.addEventListener('blur', () => {
                let value = parseInt(quantityInput.value);
                const maxValue = parseInt(quantityInput.max);

                if (isNaN(value) || value < 1) {
                  value = 1;
                } else if (value > maxValue) {
                  value = maxValue;
                }

                quantityInput.value = value;
                // 直接更新对应产品的价格
                this.updateSpecificProductPrice(currentRecommendId, currentPrice, currentComparePrice, value);
              });
            }
          });
        }

        // 新增方法：更新特定产品的价格显示
        updateSpecificProductPrice(productId, price, comparePrice, quantity) {

          // 使用querySelectorAll来获取所有匹配的价格元素（移动端和PC端）
          const priceElements = this.querySelectorAll(`.select-price-${productId}`);
          const comparePriceElements = this.querySelectorAll(`.select-compare-price-${productId}`);



          if (priceElements.length > 0 && price && quantity) {
            // 更新所有价格元素
            const formattedPrice = theme.Currency.formatMoney(price, window.shopMoneyFormat);
            priceElements.forEach((priceElement, index) => {
              priceElement.textContent = formattedPrice;
            });


            // 更新所有比较价格元素
            if (comparePriceElements.length > 0 && comparePrice) {
              const formattedComparePrice = theme.Currency.formatMoney(
                comparePrice,
                window.shopMoneyFormat
              );
              comparePriceElements.forEach((comparePriceElement, index) => {
                comparePriceElement.textContent = formattedComparePrice;

              });
            } else {
              // 如果比较价格为0，清空所有比较价格元素
              if (comparePrice == 0) {
                comparePriceElements.forEach((comparePriceElement) => {
                  comparePriceElement.textContent = '';
                });
              }
            }
          }
        }

        // 更新价格显示
        updateOptionPrice() {

          // 使用querySelectorAll来获取所有匹配的价格元素（移动端和PC端）
          const priceElements = this.querySelectorAll(`.select-price-${this.productId}`);
          const comparePriceElements = this.querySelectorAll(`.select-compare-price-${this.productId}`);




          if (priceElements.length > 0 && this.$currentPrice && this.$currentQuantity) {
            // 更新所有价格元素
            const formattedPrice = theme.Currency.formatMoney(this.$currentPrice, window.shopMoneyFormat);
            priceElements.forEach((priceElement, index) => {
              priceElement.textContent = formattedPrice;
            });

            // 更新所有比较价格元素
            if (comparePriceElements.length > 0 && this.$currentComparePrice) {
              // 如果比较价格小于或等于当前价格，隐藏比较价格
              if (this.$currentComparePrice <= this.$currentPrice) {
                comparePriceElements.forEach((comparePriceElement) => {
                  comparePriceElement.textContent = '';
                  comparePriceElement.classList.add('hidden');
                });
              } else {
                // 如果比较价格大于当前价格，显示比较价格
                const formattedComparePrice = theme.Currency.formatMoney(
                  this.$currentComparePrice,
                  window.shopMoneyFormat
                );
                comparePriceElements.forEach((comparePriceElement) => {
                  comparePriceElement.textContent = formattedComparePrice;
                  comparePriceElement.classList.remove('hidden');
                });
              }
            } else {
              // 如果比较价格为0或不存在，隐藏所有比较价格元素
              comparePriceElements.forEach((comparePriceElement) => {
                comparePriceElement.textContent = '';
                comparePriceElement.classList.add('hidden');
              });
            }
          }
        }
        initSwiper() {
          this.swiper = new Swiper(this.$cartRecommentSwiper, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            navigation: {
              nextEl: '.swiper-button-next-recommend',
              prevEl: '.swiper-button-prev-recommend',
            },
            on: {
              slideChange: function () {
                //  Swiper 切换时关闭当前活动的下拉框
                if (window.GlobalSelectManager && window.GlobalSelectManager.activeId) {
                  window.GlobalSelectManager.close(window.GlobalSelectManager.activeId);
                }
              },
            },
          });
        }

        parsePriceString(priceString) {
          if (!priceString) return 0;
          // 移除所有非数字和非小数点的字符，然后转换为数字
          return parseFloat(priceString.replace(/[^0-9.]/g, '')) || 0;
        }

        // 更新购物车组件
        async updateCartComponents(cartData) {
          try {

            // 更新购物车抽屉内容
            const cartDrawer = document.querySelector('pq-cart-drawer#CartDrawer') || document.querySelector('#CartDrawer');

            if (cartDrawer && cartData.sections && cartData.sections['pq-cart-drawer']) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(cartData.sections['pq-cart-drawer'], 'text/html');

              // 尝试多种选择器来获取购物车内容
              let newCartContent = doc.querySelector('pq-cart-drawer#CartDrawer');
              if (!newCartContent) {
                newCartContent = doc.querySelector('#CartDrawer');
              }
              if (!newCartContent) {
                newCartContent = doc.querySelector('pq-cart-drawer');
              }


              if (newCartContent) {
                // 保存当前滚动位置
                const currentScrollTop = cartDrawer.querySelector('.cart-container')?.scrollTop || 0;

                // 更新购物车内容
                cartDrawer.innerHTML = newCartContent.innerHTML;

                // 重新初始化购物车功能
                if (cartDrawer.init && typeof cartDrawer.init === 'function') {
                  cartDrawer.init();
                }

                // 恢复滚动位置
                const cartContainer = cartDrawer.querySelector('.cart-container');
                if (cartContainer) {
                  cartContainer.scrollTop = currentScrollTop;
                }
              } else {
              }
            }

            // 更新购物车图标数量
            if (cartData.sections && cartData.sections["cart-icon-bubble"]) {
              const currentCartIcon = document.querySelector("#cart-icon-bubble");
              if (currentCartIcon) {
                // cart-icon-bubble section 返回的是内部HTML内容，不是完整元素
                currentCartIcon.innerHTML = cartData.sections["cart-icon-bubble"];
              }
            }
            // 更新移动端购物车图标数量
            if (cartData.sections && cartData.sections["mobile-cart-icon-bubble"]) {
              const currentMobileCartIcon = document.querySelector("#mobile-cart-icon-bubble");
              if (currentMobileCartIcon) {
                // mobile-cart-icon-bubble section 返回的是内部HTML内容，不是完整元素
                currentMobileCartIcon.innerHTML = cartData.sections["mobile-cart-icon-bubble"];
              }
            }
            // 如果有直接的购物车数量信息，也更新图标
            if (cartData.item_count !== undefined) {
              const cartIconBubble = document.querySelector(
                "#cart-icon-bubble .absolute"
              );
              if (cartIconBubble) {
                if (cartData.item_count === 0) {
                  cartIconBubble.classList.add("hidden");
                  cartIconBubble.innerHTML = "";
                } else {
                  cartIconBubble.classList.remove("hidden");
                  cartIconBubble.innerHTML =
                    cartData.item_count >= 99
                      ? '<div class="leading-[8px]">99+</div>'
                      : `<div class="leading-[8px]">${cartData.item_count}</div>`;
                }
              }
            }

            // 显示购物车抽屉
            if (cartDrawer && cartDrawer.open && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }

          } catch (error) {
          }
        }

        initJoinCartButton() {
          // 获取所有加入购物车按钮
          const joinCartBtns = this.querySelectorAll('.cart-recommend-join-cart-btn');
          if (!joinCartBtns.length) return;

          joinCartBtns.forEach((joinCartBtn) => {
            joinCartBtn.addEventListener('click', async () => {
              try {
                // 获取当前按钮对应的商品容器
                const productContainer = joinCartBtn.closest('.swiper-slide');
                if (!productContainer) {
                  return;
                }


                // 直接使用 this.currentOption
                let selectedOption = this.currentOption;
                let variantId = null;

                // 如果有 currentOption，直接从中获取变体ID
                if (selectedOption) {
                  variantId = parseInt(selectedOption.getAttribute('data-variant_id'));
                } else {
                  // 如果没有 currentOption（第一次加载、页面刷新等），使用默认选项

                  const options = productContainer.querySelectorAll('.select-options-item, .select-option');

                  // 查找匹配的默认选项
                  options.forEach((option) => {
                    const dataId = option.getAttribute('data-variant_id');
                    const dataSelectedOrFirstAvailable = option.getAttribute('data-selected_or_first_available_variant');

                    if (dataId && dataSelectedOrFirstAvailable && dataId === dataSelectedOrFirstAvailable) {
                      selectedOption = option;
                      variantId = parseInt(dataId);
                      return;
                    }
                  });

                  // 如果还没找到，使用第一个选项
                  if (!variantId && options.length > 0) {
                    selectedOption = options[0];
                    variantId = parseInt(selectedOption.getAttribute('data-variant_id'));
                  }
                }

                if (!variantId || isNaN(variantId)) {
                  window.pqToast.showToast('error', 'Please select a variant');
                  return;
                }

                const quantityInput = productContainer.querySelector('input[type="text"]');
                const quantity = quantityInput ? parseInt(quantityInput.value) : 1;



                if (!variantId || isNaN(variantId)) {
                  window.pqToast.showToast('error', 'Invalid product variant');
                  return;
                }

                const response = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    items: [
                      {
                        id: parseInt(variantId),
                        quantity: quantity,
                      },
                    ],
                    sections: 'pq-cart-drawer,cart-icon-bubble,mobile-cart-icon-bubble',
                  }),
                });

                if (response.ok) {
                  const cartContent = await response.json();
                  // 直接更新购物车组件
                  await this.updateCartComponents(cartContent);
                } else {
                  const errorData = await response.json();
                  window.pqToast.showToast('error', errorData.description || 'Failed to Add to Cart');
                }
              } catch (error) {
                window.pqToast.showToast('error', 'Failed to Add to Cart');
              }
            });
          });
        }

        // 初始化默认选中选项
        initDefaultSelectedOptions() {
          const selectLists = this.querySelectorAll('.cart-select-menu-container-list');
          selectLists.forEach((list) => {


            // 获取所有选项
            const options = list.querySelectorAll('.select-options-item, .select-option');

            let selectedOption = null;

            // 先移除所有选项的 active 类
            options.forEach((option) => {
              option.classList.remove('active');
            });

            // 查找匹配的选项 - 根据 data-variant_id 和 data-selected_or_first_available_variant 的匹配
            options.forEach((option) => {
              const dataId = option.getAttribute('data-variant_id');
              const dataSelectedOrFirstAvailable = option.getAttribute('data-selected_or_first_available_variant');


              // 如果 data-variant_id 和 data-selected_or_first_available_variant 完全匹配，则选择这个选项
              if (dataId && dataSelectedOrFirstAvailable && dataId === dataSelectedOrFirstAvailable) {
                selectedOption = option;
                return;
              }
            });

            // 如果没有找到匹配的选项，则选择第一个作为默认选项
            if (!selectedOption && options.length > 0) {
              selectedOption = options[0];
            }

            // 设置选中状态
            if (selectedOption) {
              selectedOption.classList.add('selected', 'text-orange-500', 'active');

              // 更新对应的显示文本
              const selectHeader = list.closest('.select-options-container')?.previousElementSibling;
              const valueSpan = selectHeader?.querySelector('.select-value');
              if (valueSpan) {
                valueSpan.textContent = selectedOption.textContent;
              }
            }
          });
        }
      }
    );
  }
});

